import React, { useState } from 'react';
import AddWidgetForm from '../components/AddWidgetForm';
import WidgetList from '../components/WidgetList';
import AdminLayout from '../components/AdminLayout';

function WidgetManagerPage() {
  const [refresh, setRefresh] = useState(false);

  return (
    <AdminLayout
      title="Widget Manager"
      subtitle="Create, manage, preview, and monitor AI chat widgets across all connected sites."
    >
      <AddWidgetForm onWidgetCreated={() => setRefresh((prev) => !prev)} />
      <WidgetList key={String(refresh)} />
    </AdminLayout>
  );
}

export default WidgetManagerPage;